import React, { useState } from "react";
import { Link } from "react-router-dom";
import useReveal from "../../hooks/useReveal";

const faqs = [
  {
    q: "¿Cuánto cuesta una página web?",
    a: "Depende del tipo de página. Manejamos precios de partida: landing page desde $3,990 MXN + IVA, sitio empresarial desde $6,490, catálogo/citas/reservaciones desde $6,990 y tienda en línea desde $14,990. El precio final depende del alcance y las funciones requeridas.",
  },
  {
    q: "¿Qué tipo de página necesito?",
    a: "Depende de tu objetivo: una landing page presenta un servicio o promoción en una sola página; un sitio empresarial amplía historia, servicios y galería; un catálogo con citas o reservaciones sirve para recibir solicitudes; y una tienda en línea permite vender con carrito y pagos. Si no estás seguro, cuéntanos tu caso y te orientamos sin compromiso.",
  },
  {
    q: "¿Puedo ver una propuesta antes de contratar?",
    a: "Sí. Para landing pages y páginas informativas sencillas podemos preparar una idea visual inicial para que revises si el estilo y enfoque van con tu negocio. No aplica para sistemas, ecommerce, paneles, integraciones o desarrollos especiales, que se cotizan por separado.",
  },
  {
    q: "¿Qué significa que una página sea administrable?",
    a: "Significa que tú mismo puedes actualizar ciertos contenidos (precios, textos, imágenes) sin depender de nosotros para cada cambio. Qué tan administrable es tu página depende del producto contratado; lo revisamos contigo antes de cotizar.",
  },
  {
    q: "¿Dominio y hosting están incluidos?",
    a: "No, salvo que una propuesta indique lo contrario. Dominio y hosting se cotizan por separado.",
  },
  {
    q: "¿Cuánto tarda el desarrollo?",
    a: "Una landing page sencilla se entrega en aproximadamente 7 días hábiles. Los demás tipos de página dependen del alcance; te damos un tiempo estimado en tu cotización. Los tiempos comienzan a contar cuando nos entregas la información completa.",
  },
  {
    q: "¿Puedo solicitar cambios?",
    a: "Sí. Cada proyecto incluye una ronda de ajustes inicial. Cambios adicionales o mantenimiento continuo pueden tener costo extra según el tabulador de mantenimiento web.",
  },
  {
    q: "¿Pueden hacer una tienda en línea?",
    a: "Sí. Desarrollamos tiendas en línea con catálogo, carrito, checkout, pagos en línea y administración de pedidos, desde $14,990 MXN + IVA.",
  },
  {
    q: "¿Pueden hacer citas o reservaciones?",
    a: "Sí. Desarrollamos páginas con catálogo, citas o reservaciones desde $6,990 MXN + IVA, según lo que necesite tu negocio.",
  },
  {
    q: "¿Desarrollan sistemas a la medida?",
    a: "Sí. Además de páginas web, desarrollamos sistemas web, portales de clientes, paneles administrativos, integraciones y automatizaciones. Requiere análisis y cotización personalizada.",
  },
  {
    q: "¿La página aparecerá en Google?",
    a: "Todas nuestras páginas incluyen SEO técnico básico (estructura, metadatos y velocidad), pero no garantizamos una posición específica en los resultados de búsqueda; eso depende también de tu mercado, competencia y estrategia de contenido a largo plazo.",
  },
  {
    q: "¿Me garantizan ventas?",
    a: "No se garantizan ventas específicas. Una página profesional ayuda a presentar mejor tu negocio y facilitar el contacto, pero los resultados dependen de tu oferta, mercado, atención, reputación e inversión publicitaria.",
  },
  {
    q: "¿Puedo contratar solo imágenes o videos?",
    a: (
      <>
        Sí, por separado de tu página web. Conoce precios y ejemplos en{" "}
        <Link
          to="/otros-servicios"
          className="underline font-semibold"
          style={{ color: "var(--red)" }}
        >
          Otros servicios
        </Link>
        .
      </>
    ),
  },
  {
    q: "¿Trabajan con negocios de cualquier giro?",
    a: "Sí, siempre que el proyecto sea viable y el negocio pueda proporcionar la información necesaria para construir la página.",
  },
];

const FAQ = () => {
  useReveal();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" data-testid="section-faq" className="bdk-section bdk-split-bg">
      <div
        className="container-bdk max-w-[900px]"
        style={{ margin: "0 auto" }}
      >
        <div className="text-center mb-12 bdk-reveal bdk-reveal--up">
          <p className="kicker">Preguntas frecuentes</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            Dudas comunes,
            <br />
            respuestas claras.
          </h2>
        </div>

        <div style={{ borderTop: "1px solid var(--line)" }}>
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <article
                key={i}
                data-testid={`faq-item-${i}`}
                className="bdk-reveal bdk-reveal--up"
                style={{
                  borderBottom: "1px solid var(--line)",
                  "--reveal-delay": `${i * 40}ms`,
                }}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex justify-between items-start gap-5 py-5 text-left cursor-pointer"
                >
                  <span className="text-[15px] md:text-[16px] font-extrabold text-[#111218]">
                    {f.q}
                  </span>
                  <span
                    className="font-display text-[22px] font-black transition-transform"
                    style={{
                      color: "var(--red)",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0)",
                    }}
                  >
                    +
                  </span>
                </button>
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{
                    maxHeight: isOpen ? "300px" : "0px",
                  }}
                >
                  <p className="text-[13px] md:text-[14px] text-[#666873] pb-5 leading-relaxed">
                    {f.a}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
